<template>
    <div>
  <el-dialog
  
    class="modalFix2"
    :visible.sync="verMenu"
   :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
    >

<div class="block">
<div style="display:block; margin-bottom:10px; font-size:16px">
   <strong>Generar y descargar informe de pedidos en excel:</strong> 
   seleccione el año y mes del informe que desea obtener
    </div>

    <!-- <el-date-picker v-model="opciones" style="margin-top:10px" type="daterange" align="center" unlink-panels range-separator="-" format="dd/MM/yyyy" :value-format="'yyyyMMdd'"
        start-placeholder="desde" end-placeholder="hasta" :picker-options="pickerOptions">
    </el-date-picker> -->
    
    <el-row :gutter="20">
        <el-col :md="12" :offset="0">
            <label for="">Mes y año</label>
            <el-date-picker type="month" v-model="opciones" placeholder="Seleccione un mes y año">
            </el-date-picker>
           
        </el-col>
        <el-col :md="8" :offset="0" v-if="isAdmin && !$route.params.roche" >
            <label for="">Código de cliente</label>
            <br>

            <el-input v-model="cliente"   size="normal" label=""  :controls="false"
                controls-position="both">
            </el-input>
        </el-col>
    </el-row>
    
   
    
</div>

    <span slot="footer" >
       
        <el-button size="small" @click="verMenu = false">Regresar</el-button>
        <el-button size="small" type="success" :disabled="!opciones && cliente ? true : false" :loading="generando" @click="descargarExcel">Generar y descargar</el-button>
       
    </span>
  </el-dialog>
  
    </div>
</template>

<script>
import { EventBus } from '@/event-bus';
import { HTTP, INFORMES } from '@/axios'
    export default {
        data() {
            return {
                verMenu: false,
                datos: undefined,
                resultados: undefined,
                opciones:undefined,
                generando:false,
                isAdmin: window.sessionStorage.getItem('cliente') && JSON.parse(window.sessionStorage.getItem('cliente')).codigo == 8000 ? true : false,
                cliente: window.sessionStorage.getItem('cliente') && JSON.parse(window.sessionStorage.getItem('cliente')).codigo !== 8000
                         ? JSON.parse(window.sessionStorage.getItem('cliente')).codigo : '' ,
            
            }
        },
    watch: {
        '$route'(to, from) {
            // Put your logic here...
            console.log(to);
            console.log(from);
        }
    },
        created()
        {
            EventBus.$on('verMenuExcel', (datos, resultados) => {
                this.datos = datos
                this.resultados = resultados.length && resultados[0].TotalRows
                this.verMenu = true
            })
        },
        methods: {
            descargarExcel() {
                // let desde = this.$moment(this.opciones).
                let Fecha  = this.$moment(this.opciones).endOf('month').format('MMMM_YY')
                let nombre = this.$route.params.roche ? 'pedidos_roche_' : 'pedidos_cliente' + this.cliente + '_' 
                let datos = {
                    roche: this.$route.params.roche ? true : false,
                    cliente: this.cliente,
                    desde: this.$moment(this.opciones).startOf('month').format('YYYYMMDD 00:00:00') ,
                    hasta: this.$moment(this.opciones).endOf('month').format('YYYYMMDD 23:59:59') ,
                    nombre: nombre+Fecha,
                }
                this.generando = true
                setTimeout(() => {
                    HTTP.post(INFORMES + '/pedidosMes', datos, {
                        headers: {
                            'Authorization': `Bearer ${window.sessionStorage.getItem('token')}`,
                        }
                    }).then(res => {
                         this.generando = false
                        console.log(res.data);
                         if(res.data)
                         {
                            if(res.data.pedidos > 0)
                            {
                                 window.open(res.data.xls, '_blank')
                                
                                this.verMenu = false
                            }
                            else{
                               this.$confirm('No se encontraron pedidos para el mes solicitado', 'Sin Datos', {
                                confirmButtonText: 'Salir',
                                cancelButtonText: 'Volver',
                                type: 'warning',
                               }).then(() => {
                                   this.verMenu = false
                               }).catch(() => {
                                
                               });
                               
                                
                            }
                           
                         }
                         else {
                             this.$alert("no se pudo generar el informe, actualice la página y reintente")
                             this.verMenu = false
                         }
                         
                    })
                    .catch(() => {
                        this.generando = false
                        this.$alert("no se pudo generar el informe, actualice la página y reintente")
                        this.verMenu = false
                    })
                }, 150);
               
                  
                
                
            }
        },
    }
</script>

<style lang="scss" scoped>
.block{
    padding:20px
}
</style>